import React, { useState, useEffect, useMemo } from 'react'
import { getWorkOrderstatusBySignzy, getdowloadUrlUploadedAnalyzedStatemntBySignzy, FetchSignzyAnalyzedStatemntByID, getSignzyOverVIewStatementById } from '../../../../../containers/Admin/AdminActionCreator.component'
import Nodata from '../../../../../../images/nodata.png'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../../presentationals/Popup/Popup.component'
import moment from 'moment'

const PAGE_SIZE = 10;

// ─── helpers ────────────────────────────────────────────────────────────────

/** Flatten month-wise grouped data [{month, transactions:[...]}] into flat array */
function flattenCategoryData(categoryObj) {
    if (!categoryObj) return [];
    const txns = [];
    const monthArr = Array.isArray(categoryObj.data) ? categoryObj.data : [];
    monthArr.forEach(monthEntry => {
        if (Array.isArray(monthEntry.transactions)) {
            monthEntry.transactions.forEach(t => txns.push({ ...t, _month: monthEntry.month }));
        }
    });
    return txns;
}

/**
 * Auto-detect transactions from any value shape:
 *   - Array                      → use directly
 *   - { data: [{transactions}] } → flatten month-grouped
 *   - { transactions: [] }       → use .transactions
 */
function extractTransactions(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    if (Array.isArray(val.data)) return flattenCategoryData(val);
    if (Array.isArray(val.transactions)) return val.transactions;
    return [];
}

/**
 * Fully dynamic: iterates whatever keys exist in the tab's data object.
 * Salary gets special handling because its shape is { salary:[], salaryBreakup:{} }.
 * loanAnalysis is excluded — it has its own dedicated renderer.
 * inflows / outflows share the generic path.
 */
function getTabData(analzedData, activeTab) {
    const raw = analzedData?.[activeTab];
    if (!raw || typeof raw !== 'object') return { subCats: ['All'], subCatTxns: { All: [] } };

    const subCatTxns = {};

    // ── Salary: top-level has salary[] + salaryBreakup{} ──────────────────────
    if (activeTab === 'salary') {
        const salaryTxns = raw?.salary ?? [];
        subCatTxns['All'] = salaryTxns;
        const breakup = raw?.salaryBreakup || {};
        Object.entries(breakup).forEach(([key, val]) => {
            const txns = extractTransactions(val);
            // if (txns.length > 0) subCatTxns[key] = txns;
            // if (txns.length > 0)
            subCatTxns[key] = txns;
        });
        return { subCats: Object.keys(subCatTxns), subCatTxns };
    }

    // ── Generic: inflows / outflows ────────────────────────────────────
    // If raw itself is a single-category (has .data array directly)
    if (Array.isArray(raw.data)) {
        const txns = flattenCategoryData(raw);
        subCatTxns['All'] = txns;
        return { subCats: ['All'], subCatTxns };
    }

    // Every top-level key is a subcategory — auto-detect all
    subCatTxns['All'] = [];
    Object.entries(raw).forEach(([key, val]) => {
        const txns = extractTransactions(val);
        subCatTxns[key] = txns;
        subCatTxns['All'] = [...subCatTxns['All'], ...txns];
    });

    return { subCats: Object.keys(subCatTxns), subCatTxns };
}


// ─── main component ─────────────────────────────────────────────────────────

export default function AggregtorSignzy({ userId, admin }) {


    const [loader, setLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: '' })
    const [analzedData, setAnalyzedData] = useState({})
    const [topLevelData, setTopLevelData] = useState({})

    // table state
    const MAIN_TABS = ['inflows', 'outflows', 'salary', 'loanAnalysis'];
    const TAB_LABELS = { inflows: 'Inflows', outflows: 'Outflows', salary: 'Salary', loanAnalysis: 'Loan Analysis' };
    const [activeTab, setActiveTab] = useState('inflows');
    const [activeSubCat, setActiveSubCat] = useState('All');
    const [page, setPage] = useState(1);

    const closePopup = () => setPopup({ show: false, popupStatus: '' })
    const removePopup = () => setTimeout(() => closePopup(), 5000)

    useEffect(() => { workOrderStatus() }, [])

    const workOrderStatus = () => {
        setLoader(true)
        getWorkOrderstatusBySignzy(userId, callback => {
            setLoader(false)
            if (callback == 'ANALYSED' || callback?.trim()?.toUpperCase() == 'ANALYSED') {
                FetchStatement()
            } else if (callback == 'IN PROGRESS' || callback?.trim()?.toUpperCase() == 'IN PROGRESS') {
                setPopup({ show: true, popupStatus: 'Bank Statement is Being Processed' })
                removePopup()
            } else {
                setPopup({ show: true, popupStatus: 'Error: Please Try again later!' })
                removePopup()
            }
        })
    }

    const getDownloadedUrl = () => {
        getdowloadUrlUploadedAnalyzedStatemntBySignzy(userId, callback => {
            if (callback?.status == 200 && callback?.message == 'success') {
                getSignzyOverVIewStatementById(userId, callback => {
                    if (callback && Object.keys(callback?.data)?.length > 0) {
                        const data = callback?.data ?? {}

                        setAnalyzedData(data)
                        setTopLevelData(data?.Overview ?? {})
                    } else {
                       
                        setPopup({ show: true, popupStatus: 'Error: Please Try again later!' })
                        removePopup()
                    }
                })

            } else {
                setPopup({ show: true, popupStatus: 'Error: Please Try again later!' })
                removePopup()
            }
        })
    }

    const FetchStatement = () => {
        getSignzyOverVIewStatementById(userId, callback => {
            if (callback && Object.keys(callback?.data)?.length > 0) {
                const data = callback?.data ?? {}

                setAnalyzedData(data)
                setTopLevelData(data?.Overview ?? {})
            } else {
                getDownloadedUrl()
                // setPopup({ show: true, popupStatus: 'Error: Please Try again later!' })
                // removePopup()
            }
        })
    }

    const hasData = topLevelData && Object.keys(topLevelData).length > 0;

    // Compute tab data
    const { subCats, subCatTxns } = useMemo(
        () => getTabData(analzedData, activeTab),
        [analzedData, activeTab]
    );

    // Validate activeSubCat on tab change
    useEffect(() => {
        setActiveSubCat('All');
        setPage(1);
    }, [activeTab]);

    useEffect(() => { setPage(1); }, [activeSubCat]);

    const transactions = useMemo(() => {
        const txns = subCatTxns?.[activeSubCat] ?? [];
        return txns;
    }, [subCatTxns, activeSubCat]);

    const totalPages = Math.max(1, Math.ceil(transactions.length / PAGE_SIZE));
    const pagedTxns = transactions.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    const fmtAmount = (val) => {
        const num = parseFloat(val);
        if (isNaN(num)) return val ?? '—';
        return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <>
            {loader ? <Loader /> : ''}
            {popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ''}

            <style>{`
                /* ── Account Details Card ── */
                .signzy-details-container {
                    border-radius: 12px;
                    padding: 24px;
                    margin: 20px 0;
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03);
                }
                .signzy-details-container.has-data { background:#f4fdf8; border:1.5px solid #bbf7d0; }
                .signzy-details-container.no-data  { background:#fdf2f2; border:1.5px solid #fecaca; }
                .signzy-details-title { font-size:18px; font-weight:700; color:#1e293b; margin-bottom:24px; text-align:left; }
                .signzy-details-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:20px 24px; }
                @media(max-width:991px){ .signzy-details-grid{ grid-template-columns:repeat(2,1fr); } }
                @media(max-width:575px){ .signzy-details-grid{ grid-template-columns:1fr; } }
                .signzy-details-item { display:flex; flex-direction:column; text-align:left; }
                .signzy-details-item.span-2 { grid-column:span 2; }
                @media(max-width:575px){ .signzy-details-item.span-2{ grid-column:span 1; } }
                .signzy-details-label { font-size:12px; font-weight:600; color:#64748b; text-transform:uppercase; letter-spacing:0.05em; margin-bottom:6px; }
                .signzy-details-value { font-size:14px; font-weight:600; color:#0f172a; word-break:break-word; }
                .signzy-status-active  { color:#16a34a; font-weight:700; }
                .signzy-status-inactive{ color:#dc2626; font-weight:700; }
                .signzy-balance-value  { color:#16a34a; font-weight:700; }
                .signzy-balance-value.no-bal { color:#64748b; }

                /* ── Transaction Table Section ── */
                .txn-section {
                    background:#fff;
                    border-radius:14px;
                    border:1px solid #e2e8f0;
                    box-shadow:0 4px 12px rgba(0,0,0,0.05);
                    margin:0 0 24px 0;
                    font-family:'Inter',-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;
                    overflow:hidden;
                }
                .txn-section-header {
                    padding:20px 24px 0 24px;
                    border-bottom:1px solid #f1f5f9;
                }
                .txn-section-title {
                    font-size:17px;
                    font-weight:700;
                    color:#1e293b;
                    margin-bottom:16px;
                }

                /* Main tabs */
                .txn-main-tabs {
                    display:flex;
                    gap:4px;
                    overflow-x:auto;
                    padding-bottom:0;
                }
                .txn-main-tab {
                    padding:9px 20px;
                    border:none;
                    background:transparent;
                    font-size:13px;
                    font-weight:600;
                    color:#64748b;
                    cursor:pointer;
                    border-radius:8px 8px 0 0;
                    border-bottom:3px solid transparent;
                    white-space:nowrap;
                    transition:all 0.18s ease;
                }
                .txn-main-tab:hover { color:#3b82f6; background:#f0f7ff; }
                .txn-main-tab.active {
                    color:#3b82f6;
                    border-bottom:3px solid #3b82f6;
                    background:#f0f7ff;
                }

                /* Sub-category pills */
                .txn-subcat-bar {
                    display:flex;
                    flex-wrap:wrap;
                    gap:8px;
                    padding:14px 24px;
                    border-bottom:1px solid #f1f5f9;
                    background:#fafafa;
                }
                .txn-subcat-pill {
                    padding:5px 14px;
                    border-radius:20px;
                    font-size:12px;
                    font-weight:600;
                    border:1.5px solid #e2e8f0;
                    background:#fff;
                    color:#475569;
                    cursor:pointer;
                    transition:all 0.15s ease;
                    white-space:nowrap;
                }
                .txn-subcat-pill:hover { border-color:#3b82f6; color:#3b82f6; }
                .txn-subcat-pill.active {
                    background:#3b82f6;
                    border-color:#3b82f6;
                    color:#fff;
                    box-shadow:0 2px 6px rgba(59,130,246,0.3);
                }

                /* Table */
                .txn-table-wrap {
                    overflow-x:auto;
                    padding:0;
                }
                .txn-table {
                    width:100%;
                    border-collapse:collapse;
                    font-size:13px;
                    min-width:780px;
                }
                .txn-table thead tr {
                    background:#f8fafc;
                }
                .txn-table th {
                    padding:12px 14px;
                    font-size:11px;
                    font-weight:700;
                    color:#64748b;
                    text-transform:uppercase;
                    letter-spacing:0.05em;
                    text-align:left;
                    border-bottom:1px solid #e2e8f0;
                    white-space:nowrap;
                }
                .txn-table td {
                    padding:11px 14px;
                    color:#334155;
                    border-bottom:1px solid #f1f5f9;
                    vertical-align:middle;
                    max-width:200px;
                    word-break:break-word;
                }
                .txn-table tbody tr:last-child td { border-bottom:none; }
                .txn-table tbody tr:hover td { background:#f8fafc; }

                .txn-type-cr {
                    display:inline-block;
                    padding:2px 8px;
                    border-radius:10px;
                    font-size:11px;
                    font-weight:700;
                    background:#dcfce7;
                    color:#16a34a;
                }
                .txn-type-dr {
                    display:inline-block;
                    padding:2px 8px;
                    border-radius:10px;
                    font-size:11px;
                    font-weight:700;
                    background:#fee2e2;
                    color:#dc2626;
                }
                .txn-amount-cr { font-weight:700; color:#16a34a; }
                .txn-amount-dr { font-weight:700; color:#dc2626; }
                .txn-tags {
                    display:flex;
                    flex-wrap:wrap;
                    gap:4px;
                }
                .txn-tag {
                    display:inline-block;
                    padding:1px 7px;
                    border-radius:8px;
                    font-size:10px;
                    font-weight:600;
                    background:#f1f5f9;
                    color:#475569;
                    white-space:nowrap;
                }
                .txn-nodata {
                    text-align:center;
                    padding:48px 20px;
                    color:#94a3b8;
                }
                .txn-nodata img { max-width:100px; margin-bottom:12px; opacity:0.6; }
                .txn-nodata p { font-size:14px; font-weight:600; }

                /* Pagination */
                .txn-pagination {
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    padding:14px 24px;
                    border-top:1px solid #f1f5f9;
                    background:#fafafa;
                    flex-wrap:wrap;
                    gap:10px;
                }
                .txn-pagination-info {
                    font-size:12px;
                    color:#64748b;
                    font-weight:500;
                }
                .txn-pagination-controls {
                    display:flex;
                    align-items:center;
                    gap:4px;
                }
                .txn-page-btn {
                    min-width:32px;
                    height:32px;
                    padding:0 8px;
                    border:1.5px solid #e2e8f0;
                    border-radius:7px;
                    background:#fff;
                    font-size:12px;
                    font-weight:600;
                    color:#475569;
                    cursor:pointer;
                    transition:all 0.15s ease;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                }
                .txn-page-btn:hover:not(:disabled) { border-color:#3b82f6; color:#3b82f6; background:#f0f7ff; }
                .txn-page-btn.active { background:#3b82f6; border-color:#3b82f6; color:#fff; }
                .txn-page-btn:disabled { opacity:0.4; cursor:not-allowed; }

                /* Loan Analysis tables */
                .loan-subcat-bar {
                    display:flex;
                    flex-wrap:wrap;
                    gap:8px;
                    padding:14px 24px;
                    border-bottom:1px solid #f1f5f9;
                    background:#fafafa;
                }
                .loan-section-wrap { padding: 0 0 4px 0; }
                .loan-table-title {
                    font-size:13px;
                    font-weight:700;
                    color:#334155;
                    padding:16px 24px 10px 24px;
                    text-transform:uppercase;
                    letter-spacing:0.05em;
                }
                .loan-table {
                    width:100%;
                    border-collapse:collapse;
                    font-size:13px;
                    min-width:700px;
                }
                .loan-table th {
                    padding:11px 14px;
                    font-size:11px;
                    font-weight:700;
                    color:#64748b;
                    text-transform:uppercase;
                    letter-spacing:0.04em;
                    text-align:left;
                    border-bottom:1px solid #e2e8f0;
                    background:#f8fafc;
                    white-space:nowrap;
                }
                .loan-table td {
                    padding:11px 14px;
                    color:#334155;
                    border-bottom:1px solid #f1f5f9;
                    vertical-align:middle;
                    font-size:13px;
                }
                .loan-table tbody tr:last-child td { border-bottom:none; }
                .loan-table tbody tr:hover td { background:#f8fafc; }
                .loan-status-yes {
                    display:inline-block; padding:2px 9px;
                    border-radius:10px; font-size:11px; font-weight:700;
                    background:#dcfce7; color:#16a34a;
                }
                .loan-status-no {
                    display:inline-block; padding:2px 9px;
                    border-radius:10px; font-size:11px; font-weight:700;
                    background:#fee2e2; color:#dc2626;
                }
                .loan-divider { border:none; border-top:6px solid #f1f5f9; margin:0; }
            `}</style>

            {/* ── Account Details Card ── */}
            <div className={`signzy-details-container ${hasData ? 'has-data' : 'no-data'}`}>
                <div className="signzy-details-title">Account Details</div>
                <div className="signzy-details-grid">
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Account Holder</span>
                        <span className="signzy-details-value">{topLevelData?.accHolderName || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Account Number</span>
                        <span className="signzy-details-value">{topLevelData?.accountNumber || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Account Type</span>
                        <span className="signzy-details-value">{topLevelData?.accType || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">IFSC Code</span>
                        <span className="signzy-details-value">{topLevelData?.ifscCode || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Bank Name</span>
                        <span className="signzy-details-value">{topLevelData?.bankName || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">MICR Code</span>
                        <span className="signzy-details-value">{topLevelData?.micrCode || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Mobile</span>
                        <span className="signzy-details-value">{topLevelData?.phoneNumber || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Bank Score</span>
                        <span className="signzy-details-value">{topLevelData?.bankScore || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item span-2">
                        <span className="signzy-details-label">Address</span>
                        <span className="signzy-details-value">{topLevelData?.address || 'N/A'}</span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Account Status</span>
                        <span className={hasData ? 'signzy-status-active' : 'signzy-status-inactive'}>
                            {hasData ? 'ACTIVE' : 'INACTIVE'}
                        </span>
                    </div>
                    <div className="signzy-details-item">
                        <span className="signzy-details-label">Avg Bank Balance</span>
                        <span className={topLevelData?.abbWithoutLoan ? 'signzy-balance-value' : 'signzy-balance-value no-bal'}>
                            {topLevelData?.abbWithoutLoan
                                ? `₹${Number(topLevelData.abbWithoutLoan).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
                                : 'N/A'}
                        </span>
                    </div>
                </div>
            </div>

            {/* ── Transaction Table ── */}
            <div className="txn-section">
                <div className="txn-section-header">
                    <div className="txn-section-title">Transaction Details</div>
                    <div className="txn-main-tabs">
                        {MAIN_TABS.map(tab => (
                            <button
                                key={tab}
                                className={`txn-main-tab${activeTab === tab ? ' active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {TAB_LABELS[tab]}
                            </button>
                        ))}
                    </div>
                </div>

                {/* ───────── LOAN ANALYSIS ──────────────────────── */}
                {activeTab === 'loanAnalysis' && (() => {
                    const loanRaw = analzedData?.loanAnalysis?.loanAnalysis ?? {};
                    const loanDetails = loanRaw.loanDetails
                    // ? loanRaw.loanDetails.filter(l => l.lender) // skip summary rows
                    // : [];
                    const emiCharges = loanRaw?.emiReturnCharges

                    // ? loanRaw.emiReturnCharges
                    // : [];

                    const LOAN_SUBCATS = [
                        { key: 'loanDetails', label: 'Loan Details', count: loanDetails.length },
                        { key: 'emiReturnCharges', label: 'EMI Return Charges', count: emiCharges.length },
                    ];
                    const loanSubCat = activeSubCat === 'All' ? 'loanDetails' : activeSubCat;

                    return (
                        <div className="loan-section-wrap">
                            {/* Sub-cat pills */}
                            <div className="loan-subcat-bar">
                                {LOAN_SUBCATS.map(sc => (
                                    <button
                                        key={sc.key}
                                        className={`txn-subcat-pill${loanSubCat === sc.key ? ' active' : ''}`}
                                        onClick={() => setActiveSubCat(sc.key)}
                                    >
                                        {sc.label}
                                        <span style={{ marginLeft: 5, opacity: 0.75, fontWeight: 500 }}>({sc.count})</span>
                                    </button>
                                ))}
                            </div>

                            {/* Loan Details Table */}
                            {loanSubCat === 'loanDetails' && (
                                <div className="txn-table-wrap">
                                    {loanDetails.length === 0 ? (
                                        <div className="txn-nodata"><img src={Nodata} alt="No Data" /><p>No loan details found</p></div>
                                    ) : (
                                        <table className="loan-table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Lender</th>
                                                    <th>EMI Started On</th>
                                                    <th>EMI Debit</th>
                                                    <th>Obligation Amt</th>
                                                    <th>EMI Status</th>
                                                    <th>Loan Credit</th>
                                                    <th>Loan Debit</th>
                                                    <th>Bank (EMI Running)</th>
                                                    <th>Remarks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loanDetails && loanDetails?.length > 0 && loanDetails?.map((loan, idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ color: '#94a3b8', fontWeight: 600 }}>{idx + 1}</td>
                                                        <td style={{ fontWeight: 600, color: '#1e293b' }}>{loan.lender || '—'}</td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>
                                                            {loan.emiStartedOn ? moment(loan.emiStartedOn).format('DD MMM YYYY') : '—'}
                                                        </td>
                                                        <td style={{ fontWeight: 700, color: '#dc2626' }}>
                                                            {loan.emiDebit != null ? fmtAmount(loan.emiDebit) : '—'}
                                                        </td>
                                                        <td style={{ fontWeight: 600 }}>
                                                            {loan.emiObligationAmt != null ? fmtAmount(loan.emiObligationAmt) : '—'}
                                                        </td>
                                                        <td>
                                                            {loan.emiObligationStatus
                                                                ? <span className={loan.emiObligationStatus === 'Yes' ? 'loan-status-yes' : 'loan-status-no'}>{loan.emiObligationStatus}</span>
                                                                : '—'}
                                                        </td>
                                                        <td style={{ color: '#16a34a', fontWeight: 600 }}>
                                                            {loan.loanCredit != null ? fmtAmount(loan.loanCredit) : '—'}
                                                        </td>
                                                        <td style={{ color: '#dc2626', fontWeight: 600 }}>
                                                            {loan.loanDebit != null ? fmtAmount(loan.loanDebit) : '—'}
                                                        </td>
                                                        <td>{loan.bankNameEmiRunning || '—'}</td>
                                                        <td>{loan.remarks || '—'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            )}

                            {/* EMI Return Charges Table */}
                            {loanSubCat === 'emiReturnCharges' && (
                                <div className="txn-table-wrap">
                                    {emiCharges.length === 0 ? (
                                        <div className="txn-nodata"><img src={Nodata} alt="No Data" /><p>No EMI return charges found</p></div>
                                    ) : (
                                        <table className="loan-table">
                                            <thead>
                                                <tr>
                                                    <th>Month</th>
                                                    <th>EMI Bounce Count</th>
                                                    <th>Return Charges Count</th>
                                                    <th>Return Charges Amt</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emiCharges && emiCharges?.length > 0 && emiCharges?.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ fontWeight: 600, color: '#1e293b' }}>{row.month || '—'}</td>
                                                        <td>
                                                            <span className={row.emiBounceCount > 0 ? 'loan-status-no' : 'loan-status-yes'}>
                                                                {row.emiBounceCount ?? 0}
                                                            </span>
                                                        </td>
                                                        <td>{row.emiReturnChargesCount ?? 0}</td>
                                                        <td style={{ fontWeight: 700, color: row.emiReturnChargesAmt > 0 ? '#dc2626' : '#16a34a' }}>
                                                            {fmtAmount(row.emiReturnChargesAmt ?? 0)}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })()}

                {/* ───────── INFLOWS / OUTFLOWS / SALARY (generic transaction table) ─────── */}
                {activeTab !== 'loanAnalysis' && (
                    <>
                        {/* Sub-category pills */}
                        {subCats.length > 1 && (
                            <div className="txn-subcat-bar">
                                {subCats.map(sc => (
                                    <button
                                        key={sc}
                                        className={`txn-subcat-pill${activeSubCat === sc ? ' active' : ''}`}
                                        onClick={() => setActiveSubCat(sc)}
                                    >
                                        {sc}
                                        <span style={{ marginLeft: 5, opacity: 0.75, fontWeight: 500 }}>
                                            ({(subCatTxns?.[sc] ?? []).length})
                                        </span>
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* Table */}
                        <div className="txn-table-wrap">
                            {pagedTxns.length === 0 ? (
                                <div className="txn-nodata">
                                    <img src={Nodata} alt="No Data" />
                                    <p>No transactions found</p>
                                </div>
                            ) : (
                                <table className="txn-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Date</th>
                                            <th>Particular</th>
                                            <th>Counterparty</th>
                                            <th>Amount</th>
                                            <th>Balance</th>
                                            <th>Type</th>
                                            <th>Categories</th>
                                            <th>Tags</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagedTxns.map((txn, idx) => {
                                            const isCr = (txn.type || '').toUpperCase() === 'CR';
                                            return (
                                                <tr key={txn.id ?? idx}>
                                                    <td style={{ color: '#94a3b8', fontWeight: 600, whiteSpace: 'nowrap' }}>
                                                        {(page - 1) * PAGE_SIZE + idx + 1}
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        {txn.date ? moment(txn.date).format('DD MMM YYYY') : '—'}
                                                    </td>
                                                    <td style={{ fontSize: 12, maxWidth: 180 }}>{txn.particular || '—'}</td>
                                                    <td style={{ fontSize: 12 }}>{txn.counterparty || '—'}</td>
                                                    <td className={isCr ? 'txn-amount-cr' : 'txn-amount-dr'} style={{ whiteSpace: 'nowrap' }}>
                                                        {fmtAmount(txn.amount)}
                                                    </td>
                                                    <td style={{ whiteSpace: 'nowrap', fontWeight: 600 }}>
                                                        {fmtAmount(txn.balance ?? txn.computedBalance)}
                                                    </td>
                                                    <td>
                                                        <span className={isCr ? 'txn-type-cr' : 'txn-type-dr'} style={{ whiteSpace: 'nowrap' }}>
                                                            {txn.type || '—'}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: 12 }}>{txn.categories || '—'}</td>
                                                    <td>
                                                        {txn.tags ? (
                                                            <div className="txn-tags">
                                                                {txn.tags.split(',').map((t, i) => (
                                                                    <span key={i} className="txn-tag">{t.trim()}</span>
                                                                ))}
                                                            </div>
                                                        ) : '—'}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {/* Custom Pagination */}
                        {transactions.length > 0 && (
                            <div className="txn-pagination">
                                <div className="txn-pagination-info">
                                    Showing {Math.min((page - 1) * PAGE_SIZE + 1, transactions.length)}–{Math.min(page * PAGE_SIZE, transactions.length)} of {transactions.length} transactions
                                </div>
                                <div className="txn-pagination-controls">
                                    <button className="txn-page-btn" disabled={page === 1} onClick={() => setPage(1)} title="First">«</button>
                                    <button className="txn-page-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)} title="Previous">‹</button>
                                    {(() => {
                                        const pages = [];
                                        let start = Math.max(1, page - 2);
                                        let end = Math.min(totalPages, start + 4);
                                        if (end - start < 4) start = Math.max(1, end - 4);
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                                <button
                                                    key={i}
                                                    className={`txn-page-btn${page === i ? ' active' : ''}`}
                                                    onClick={() => setPage(i)}
                                                >{i}</button>
                                            );
                                        }
                                        return pages;
                                    })()}
                                    <button className="txn-page-btn" disabled={page === totalPages} onClick={() => setPage(p => p + 1)} title="Next">›</button>
                                    <button className="txn-page-btn" disabled={page === totalPages} onClick={() => setPage(totalPages)} title="Last">»</button>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    )
}